import { render, staticRenderFns } from "./UpListDocs.vue?vue&type=template&id=561c0396"
import script from "./UpListDocs.vue?vue&type=script&lang=js"
export * from "./UpListDocs.vue?vue&type=script&lang=js"
import style0 from "./UpListDocs.vue?vue&type=style&index=0&id=561c0396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports